/* Publish by EComposer at 2026-10-08 06:48:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c56a3eclqcj"]=  window.__ectimmers["ecom-c56a3eclqcj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-c56a3eclqcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c56a3eclqcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qcmfjf4xguf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qcmfjf4xguf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tl577oqk5fm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tl577oqk5fm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0sepyjuelkap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0sepyjuelkap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fzvw8a02ns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fzvw8a02ns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnn9e1nuo2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnn9e1nuo2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2t79mk54yqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2t79mk54yqd', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nzvtttsanye"]=  window.__ectimmers["ecom-nzvtttsanye"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-nzvtttsanye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzvtttsanye', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}